import { LogOut, UserRound } from "lucide-react";

import { signOut } from "@/auth/sign-out";
import { ChatAvailabilityToggle } from "@/components/chat/chat-availability-toggle";
import { Button } from "@nt/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@nt/ui/dropdown-menu";
import { SidebarTrigger } from "@nt/ui/sidebar";

/**
 * Mobile-only top bar for the admin console. On desktop the sidebar is always
 * visible (this bar is `md:hidden`); on mobile it hosts the trigger that opens
 * the shadcn sidebar sheet plus the account menu.
 */
export function AdminNavbar() {
  return (
    <header className="flex h-14 shrink-0 items-center gap-2 border-b border-border bg-background px-4 md:hidden">
      <SidebarTrigger className="-ml-1" />
      <div className="flex min-w-0 flex-1 items-center gap-2">
        <img
          src="/nonresidentTaxIcon-forest.svg"
          alt=""
          width={24}
          height={24}
          className="size-6 shrink-0 rounded-sm"
        />
        <span className="truncate text-sm font-semibold text-foreground">
          Nonresident Tax
        </span>
        <span className="text-sm text-muted-foreground">Admin</span>
      </div>
      <DropdownMenu>
        <DropdownMenuTrigger
          render={
            <Button variant="ghost" size="icon-sm" aria-label="Account" />
          }
        >
          <UserRound className="size-5" />
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="w-56">
          <ChatAvailabilityToggle className="px-2 py-1.5" />
          <DropdownMenuSeparator />
          <DropdownMenuItem onClick={() => void signOut()}>
            <LogOut className="size-4 text-muted-foreground" />
            Sign out
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </header>
  );
}
